export default function ErrorState({ message, onRetry }) {
  return (
    <div className="text-center py-16">
      <div className="text-4xl mb-3">&#9888;&#65039;</div>
      <div className="font-semibold text-red-700 mb-2">Something went wrong</div>
      <div className="text-sm text-gray-500 mb-4 max-w-md mx-auto">{message}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-4 py-2 bg-gray-800 text-white rounded-lg text-sm font-semibold hover:bg-gray-700"
        >
          Try Again
        </button>
      )}
    </div>
  );
}
